(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fiive-card-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.fiiveCardConfidenceReady) return;
  window.fiiveCardConfidenceReady = true;
  let method = 'free';
  const ranges = {free:[7,14],standard:[6,10],express:[3,5]};
  const calendarDate = () => {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(part => [part.type,part.value]));
    return new Date(Date.UTC(Number(values.year),Number(values.month)-1,Number(values.day),12));
  };
  const addBusinessDays = (today, days) => {
    const date = new Date(today);
    let remaining = Math.ceil(days);
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate()+1);
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6) remaining--;
    }
    return date;
  };
  const scan = root => {
    const cards = [...(root.matches?.('[data-fp-shipping-estimate]') ? [root] : []), ...root.querySelectorAll('[data-fp-shipping-estimate]')];
    const today = calendarDate();
    const lang = document.documentElement.lang || 'en-US';
    const month = new Intl.DateTimeFormat(lang, {month:'short',timeZone:'UTC'});
    const day = new Intl.DateTimeFormat(lang, {day:'numeric',timeZone:'UTC'});
    for (const card of cards) {
      const select = card.querySelector('[data-fp-estimate-method]');
      if (select && select.value !== method) select.value = method;
      if (card.dataset.datesAvailable !== 'true') continue;
      const local = card.dataset.localDelivery === 'true';
      let range = local ? [4,7] : ranges[method];
      const valid = card.dataset.verified === 'true' && card.dataset.total === 'true' && new Date(card.dataset.until).getTime() > Date.now();
      if (!local && method === 'free' && valid) range = [Number(card.dataset.min),Number(card.dataset.max)];
      if (card.dataset.country !== 'US' && !valid) continue;
      if (!range || !range.every(Number.isFinite) || range[0] < 0 || range[1] < range[0] || range[1] > 60) continue;
      const start = addBusinessDays(today,range[0]);
      const end = addBusinessDays(today,range[1]);
      const sameMonth = start.getUTCMonth() === end.getUTCMonth() && start.getUTCFullYear() === end.getUTCFullYear();
      const dates = month.format(start)+' '+day.format(start)+'–'+(sameMonth?'':month.format(end)+' ')+day.format(end);
      const output = card.querySelector('[data-fp-arrival]');
      if (output.textContent !== dates) output.textContent = dates;
      const label = card.querySelector('[data-fp-delivery-label]');
      const nextLabel = local ? card.dataset.localLabel : card.dataset[method+'Label'];
      if (nextLabel && label.textContent !== nextLabel) label.textContent = nextLabel;
    }
  };
  const boot = () => {
    scan(document);
    document.addEventListener('change', event => {
      if (!event.target.matches('[data-fp-estimate-method]')) return;
      method = event.target.value;
      scan(document);
    });
    document.addEventListener('visibilitychange', () => {if (!document.hidden) scan(document);});
    setInterval(() => scan(document), 60000);
    new MutationObserver(changes => {
      for (const change of changes) for (const node of change.addedNodes) {
        if (node.nodeType === 1) scan(node);
      }
    }).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fiive-dynamic-card"] && !Shopify.designMode) return;
  try {
    (() => {
  if(window.fiiveDynamicCardsReady)return;
  window.fiiveDynamicCardsReady=true;
  document.addEventListener('click',event=>{if(event.target.closest('[data-fp-dc-gift]'))document.querySelector('.fp-gift-launcher')?.click();});
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-fp-dc-form]');if(!form)return;event.preventDefault();
    const button=form.querySelector('button'),status=form.closest('[data-fp-dynamic-card]').querySelector('.fp-dc-status');if(button.disabled)return;
    button.disabled=true;button.setAttribute('aria-busy','true');status.textContent=button.dataset.adding;
    try{const response=await fetch(form.action,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});const result=await response.json();if(!response.ok)throw new Error(result.description||button.dataset.error);status.textContent=button.dataset.added;const interestCard=form.closest('[data-fp-dynamic-card]');window.FiivePersonalization?.record('type',interestCard.dataset.productType,4);window.FiivePersonalization?.record('product',interestCard.dataset.productId,2);window.dispatchEvent(new CustomEvent('cart:refresh'));window.dispatchEvent(new CustomEvent('cart:open'));}
    catch(error){status.textContent=error.message||button.dataset.error;}
    finally{button.disabled=false;button.removeAttribute('aria-busy');}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fiive-privacy-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-fp-privacy]');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const api = () => window.Shopify?.customerPrivacy;
  const open = () => {
    const consent = api()?.currentVisitorConsent?.() || {};
    for (const name of ['preferences','analytics','marketing']) dialog.querySelector(`[name="${name}"]`).checked = consent[name] === 'yes';
    dialog.showModal();
  };
  const save = reject => {
    const privacy = api();
    if (!privacy) return;
    const consent = Object.fromEntries(['preferences','analytics','marketing'].map(name => [name, reject ? false : dialog.querySelector(`[name="${name}"]`).checked]));
    privacy.setTrackingConsent(consent, result => {
      if (result?.error) return;
      dialog.close();
      root.querySelector('[data-fp-privacy-open]').focus();
    });
  };
  root.querySelector('[data-fp-privacy-open]').addEventListener('click', open);
  root.querySelector('[data-fp-privacy-close]').addEventListener('click', () => dialog.close());
  root.querySelector('[data-fp-privacy-reject]').addEventListener('click', () => save(true));
  root.querySelector('[data-fp-privacy-save]').addEventListener('click', () => save(false));
  const ready = () => { if (api()?.shouldShowBanner?.() && !document.querySelector('#shopify-pc__banner')) open(); };
  if (api()) ready();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api', version:'0.1'}], error => { if (!error) ready(); });
})();
  } catch(e) { console.error(e); }
})();

})();
